import React from "react";
import Modal from "../ui/Modal";
import { ReactMediaRecorder } from "react-media-recorder";
import { useRef } from "react";
import { useEffect } from "react";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa";
import { FaStop } from "react-icons/fa";
import { useState } from "react";
import { MdArrowBack } from "react-icons/md";
import { IoMdSend } from "react-icons/io";
import { FaCheckCircle } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import { MdFiberSmartRecord } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";

import { toast } from "react-toastify";
import { setProfile } from "../../features/authSlice";
import FormLoader from "../ui/FormLoader";
const VerificationTrabajadorDialog = ({ open, setOpen, profile }) => {
  const [step, setStep] = useState(1);
  const [isSending,setIsSending]=useState(false)
  const [selectedFileDni, setSelectedFileDni] = useState(null);
  const [selectedFileCv, setSelectedFileCv] = useState(null);
  const [selectedFileContrato, setSelectedFileContrato] = useState(null);
  const [uploadedVideoDoc, setUploadedVideoDoc] = useState(null);
  const [selectedFileTypeDni, setSelectedFileTypeDni] = useState("");
  const [selectedFileTypeCv, setSelectedFileTypeCv] = useState("");
  const [selectedFileTypeContrato, setSelectedFileTypeContrato] = useState("");


  const [verificationText, setVerificationText] = useState("");
  const getVerificacationText = async () => {
    try {
      const response = await axios.get(
        `${BACKEND}/api/trabajadoresVerificacionTexto?limit=1`
      );
      if (response.data.docs.length > 0) {
        setVerificationText(response.data.docs[0].text);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(()=>{
    getVerificacationText();
  },[])
    
  const dispatch=useDispatch()
  const handleFileUploadDni = (event) => {
    const file = event.target.files[0];
    if (file.size > 5 * 1000000) {
      window.alert("Archivo superior a 5mb");
      return;
    }
    setSelectedFileDni(file);
    if (file) {
      // Update state with the selected file
      setSelectedFileDni(file);
      setSelectedFileTypeDni(file.type);
    }
  };


  const handleFileUploadCv = (event) => {
    const file = event.target.files[0];
    if (file.size > 5 * 1000000) {
      window.alert("Archivo superior a 5mb");
      return;
    }
    setSelectedFileCv(file);
    if (file) {
      // Update state with the selected file
      setSelectedFileCv(file);
      setSelectedFileTypeCv(file.type);
    }
  };

  const handleFileUploadContrato = (event) => {
    const file = event.target.files[0];
    if (file.size > 5 * 1000000) {
      window.alert("Archivo superior a 5mb");
      return;
    }
    setSelectedFileContrato(file);
    if (file) {
      // Update state with the selected file
      setSelectedFileContrato(file);
      setSelectedFileTypeContrato(file.type);
    }
  };

  const uploadVideo = async (blobUrl) => {
    const formDataVideo = new FormData();
    if (blobUrl) {
      await fetch(blobUrl)
        .then((response) => response.blob())
        .then((blob) => {
          // Append the blob to FormData
          formDataVideo.append(
            "file",
            blob,
            `recorded_video_${
              profile?.name ? profile?.name : ""
            }_${new Date().toISOString()}.mp4`
          );

          axios
            .post(
              `${BACKEND}/api/trabajadoresVerificacionVideos`,
              formDataVideo,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then(({ data }) => {
              setUploadedVideoDoc(data.doc);
              toast.success("Video subido exitosamente");
            })
            .catch((e) => console.log(e));

          // Now you can use 'formDataVideo' in your fetch request or elsewhere
        })
        .catch((error) => {
          console.error("Error fetching blob content:", error);
        });
    }
  };

  const submitVerification = async () => {
    setIsSending(true)
  try {
    const formDataDni = new FormData();
    if (selectedFileDni) {
      formDataDni.append("file", selectedFileDni);
    }
    const formDataCv = new FormData();
    if (selectedFileCv) {
      formDataCv.append("file", selectedFileCv);
    }

    const formDataContrato = new FormData();
    if (selectedFileContrato) {
      formDataContrato.append("file", selectedFileContrato);
    }

    const dniResponse = selectedFileDni
      ? await axios.post(`${BACKEND}/api/trabajadoresDni`, formDataDni, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
      : null;

    const cvResponse = selectedFileCv
      ? await axios.post(`${BACKEND}/api/trabajadoresCv`, formDataCv, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
      : null;

    const contratoResponse = selectedFileContrato
      ? await axios.post(
          `${BACKEND}/api/trabajadoresContratos`,
          formDataContrato,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
      : null;

    await axios.post(`${BACKEND}/api/trabajadoresVerificacion`, {
      trabajador: profile?.id,
      video: uploadedVideoDoc ? uploadedVideoDoc.id : null,
      dni: selectedFileDni ? dniResponse.data.doc.id : null,
      cv: selectedFileDni && cvResponse ? cvResponse.data.doc.id : null,
      contrato:
        selectedFileContrato && contratoResponse
          ? contratoResponse.data.doc.id
          : null,
    });

   const responseProfile=  await axios.put(`${BACKEND}/api/trabajadores/${profile?.id}`, {
        verificado:true
      });
    setOpen(false)
    toast.success("Verificación enviada correctamente")
     dispatch(setProfile(responseProfile.data.doc))
  } catch (error) {
    
  }finally{
    setIsSending(false)
  }


  };

  return (
    <Modal title="Verificación de trabajador" activeModal={open} onClose={() => setOpen(false)}>
      {step === 1 && (
        <div>
          <div className="">
            <div className=" flex justify-start gap-3 items-center flex-wrap text-xs px-3 py-2 rounded-md text-center bg-blue-600 bg-opacity-10 text-blue-600">
              <FaPlay />Para verificarte, realiza una grabación  leyendo el texto que dice a
              continuación 
            </div>
            <div className=" p-2">
              <p className=" text-base font-semibold text-slate-700">
                {" "}
                Yo {profile?.name},{" "}
              </p>

             
              <p className="text-xs text-slate-700  whitespace-pre-line text-justify">
                {verificationText}
              </p>
            </div>
          </div>
          <ReactMediaRecorder
            video
            render={({
              status,
              startRecording,
              pauseRecording,
              resumeRecording,
              stopRecording,
              mediaBlobUrl,
              previewStream,
            }) => (
              <div>
                {mediaBlobUrl !== undefined && !previewStream?.active && (
                  <div className=" pt-8">
                    <video
                      className=" rounded-lg"
                      src={mediaBlobUrl}
                      width={600}
                      height={500}
                      controls
                      autoPlay
                      loop
                    />
                  </div>
                )}

                {
                  <VideoPreview
                    stream={previewStream}
                    status={status}
                    resumeRecording={resumeRecording}
                    startRecording={startRecording}
                  />
                }

                <div
                  className={` grid pt-6  ${
                    status === "idle" || status === "stopped"
                      ? " grid-cols-1"
                      : " grid-cols-2"
                  }`}
                >
                  {status === "idle" && (
                    <div className="flex flex-col gap-2 justify-center items-center">
                      <div className="">
                        <button
                          className=" bg-green-500 bg-opacity-10 hover:bg-opacity-20 text-green-500 p-3 rounded-full"
                          onClick={startRecording}
                        >
                          <FaPlay />
                        </button>
                      </div>
                      <span className=" text-green-600 text-xs text-center">
                        Probar camara
                      </span>
                    </div>
                  )}

                  {status === "stopped" && (
                    <div className="flex flex-col gap-2 justify-center items-center">
                      <div className="">
                        <button
                          className=" bg-green-500 bg-opacity-10 hover:bg-opacity-20 text-green-500 p-3 rounded-full"
                          onClick={startRecording}
                        >
                          <FaPlay />
                        </button>
                      </div>
                      <span className=" text-green-600 text-xs text-center">
                        {mediaBlobUrl ? "Grabar otra vez" : "Empezar a grabar"}
                      </span>
                    </div>
                  )}
                  {(status === "recording" || status === "paused") && (
                    <>
                      {status === "recording" && (
                        <div className="flex justify-center">
                          <button
                            className=" bg-green-500 bg-opacity-10 hover:bg-opacity-20 text-green-500 p-3 rounded-full"
                            onClick={pauseRecording}
                          >
                            <FaPause />
                          </button>
                        </div>
                      )}

                      {status === "paused" && (
                        <div className="flex justify-center">
                          <button
                            className=" bg-green-500 bg-opacity-10 hover:bg-opacity-20 text-green-500 p-3 rounded-full"
                            onClick={resumeRecording}
                          >
                            <FaPlay />
                          </button>
                        </div>
                      )}
                      <div className="flex justify-center">
                        <button
                          className=" bg-yellow-500 bg-opacity-10 hover:bg-opacity-20 text-yellow-500 p-3 rounded-full"
                          onClick={stopRecording}
                        >
                          <FaStop />
                        </button>
                      </div>
                    </>
                  )}
                </div>
                <div className=" pt-10 flex justify-center">
                  <button
                    type="button"
                    disabled={!mediaBlobUrl}
                    className={` ${
                      mediaBlobUrl ? " hover:bg-opacity-20" : " opacity-50"
                    } bg-green-500 flex justify-start items-center gap-4 bg-opacity-10  text-green-500 p-3 rounded-full`}
                    onClick={() => {
                      setStep(2);
                      uploadVideo(mediaBlobUrl);
                    }}
                  >
                    <FaPlay />
                    Siguiente
                  </button>
                </div>
              </div>
            )}
          />
        </div>
      )}

      {step === 2 && (
        <div>
          {uploadedVideoDoc && (
            <>
              <div className=" pb-4 flex justify-center">
                <video
                  src={uploadedVideoDoc.url}
                  autoPlay
                  loop
                  className=" rounded-full w-20 h-20 object-cover "
                />
              </div>
              <div className="flex justify-center pb-6">
                <button
                  type="button"
                  className={`hover:bg-opacity-10
                    } bg-green-500 flex justify-start items-center gap-4 bg-opacity-5  text-green-500 p-3 rounded-full`}
                  onClick={() => setStep(1)}
                >
                  <MdFiberSmartRecord />
                  Grabar otra vez
                </button>
              </div>{" "}
            </>
          )}
          <div className=" pb-6">
            <p className="block mb-2 text-sm font-medium text-gray-900">
              Subir DNI (*)
            </p>
            {selectedFileDni && selectedFileTypeDni.startsWith("image/") && (
              <div>
                <img
                  src={URL.createObjectURL(selectedFileDni)} // Use createObjectURL for local files
                  style={{ maxWidth: "100%", maxHeight: "200px" }}
                  className=" rounded-md mx-auto p-2"
                />
              </div>
            )}
            {selectedFileDni && (
              <div className=" w-full flex justify-center items-center gap-4">
                <div className=" flex justify-center gap-2 items-center bg-green-50 text-green-700 rounded-md p-2">
                  {selectedFileDni.name}
                  <FaCheckCircle />
                </div>
                <button
                  onClick={() => {
                    setSelectedFileTypeDni("");
                    setSelectedFileDni(null);
                  }}
                  className="p-2 bg-red-50 rounded-md flex justify-center text-red-700 hover:text-red-800"
                >
                  <MdClose />
                </button>
              </div>
            )}
            {!selectedFileDni && (
              <label
                htmlFor="dropzone-file"
                onDrop={handleFileUploadDni}
                className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
              >
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg
                    className="w-8 h-8 mb-4 text-gray-500 "
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500 ">
                    <span className="font-semibold">
                      Click para subir tu imagen
                    </span>
                  </p>
                  <p className="text-xs text-gray-500 ">
                    SVG, PNG, JPG , WEBP, PDF, DOC, DOCX, XLS (MAX. 5MB)
                  </p>
                </div>
                <input
                  onChange={handleFileUploadDni}
                  id="dropzone-file"
                  accept=" image/*"
                  type="file"
                  className="hidden"
                />
              </label>
            )}
          </div>
          <div className=" pb-6">
            <p className="block mb-2 text-sm font-medium text-gray-900">
              Subir CV (*)
            </p>

            {selectedFileCv && (
              <div className=" w-full flex justify-center items-center gap-4">
                <div className=" flex justify-center gap-2 items-center bg-green-50 text-green-700 rounded-md p-2">
                  {selectedFileCv.name}
                  <FaCheckCircle />
                </div>
                <button
                  onClick={() => {
                    setSelectedFileTypeCv("");
                    setSelectedFileCv(null);
                  }}
                  className="p-2 bg-red-50 rounded-md flex justify-center text-red-700 hover:text-red-800"
                >
                  <MdClose />
                </button>
              </div>
            )}
            {!selectedFileCv && (
              <label
                htmlFor="dropzone-file-cv"
                onDrop={handleFileUploadCv}
                className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
              >
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg
                    className="w-8 h-8 mb-4 text-gray-500 "
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500 ">
                    <span className="font-semibold">
                      Click para subir tu documento
                    </span>
                  </p>
                  <p className="text-xs text-gray-500 ">
                    PDF, DOC, DOCX, XLS (MAX. 5MB)
                  </p>
                </div>
                <input
                  onChange={handleFileUploadCv}
                  id="dropzone-file-cv"
                  accept="application/*"
                  type="file"
                  className="hidden"
                />
              </label>
            )}
          </div>
          <div className=" pb-6">
            <p className="block mb-2 text-sm font-medium text-gray-900">
              Subir Contrato
            </p>

            {selectedFileContrato && (
              <div className=" w-full flex justify-center items-center gap-4">
                <div className=" flex justify-center gap-2 items-center bg-green-50 text-green-700 rounded-md p-2">
                  {selectedFileContrato.name}
                  <FaCheckCircle />
                </div>
                <button
                  onClick={() => {
                    setSelectedFileTypeContrato("");
                    setSelectedFileContrato(null);
                  }}
                  className="p-2 bg-red-50 rounded-md flex justify-center text-red-700 hover:text-red-800"
                >
                  <MdClose />
                </button>
              </div>
            )}
            {!selectedFileContrato && (
              <label
                htmlFor="dropzone-file-contrato"
                onDrop={handleFileUploadContrato}
                className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
              >
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg
                    className="w-8 h-8 mb-4 text-gray-500 "
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500 ">
                    <span className="font-semibold">
                      Click para subir tu documento
                    </span>
                  </p>
                  <p className="text-xs text-gray-500 ">
                    PDF, DOC, DOCX, XLS (MAX. 5MB)
                  </p>
                </div>
                <input
                  onChange={handleFileUploadContrato}
                  id="dropzone-file-contrato"
                  accept="application/*"
                  type="file"
                  className="hidden"
                />
              </label>
            )}
          </div>
          <div className=" pt-10 flex justify-center gap-2">
            <button
              type="button"
              onClick={submitVerification}
              disabled={isSending || !selectedFileDni || !selectedFileCv}
              className={`hover:bg-opacity-30 font-semibold
                    bg-green-500 flex justify-start items-center gap-4 bg-opacity-20  text-green-500 py-3 px-6 rounded-full`}
            >
              {isSending ? <FormLoader className={" w-full h-8"} colour={"white"}/> : <>Enviar
              <IoMdSend /></>}
            </button>
          </div>{" "}
        </div>
      )}
    </Modal>
  );
};

export default VerificationTrabajadorDialog;

const VideoPreview = ({ stream, status, resumeRecording, startRecording }) => {
  useEffect(() => {}, []);
  const videoRef = useRef(null);
  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
    }
  }, [stream]);
  if (!stream) {
    return null;
  }
  if (!stream.active) {
    return null;
  }
  return (
    <div className="relative pt-4">
      <video
        className=" rounded-md"
        ref={videoRef}
        width={600}
        height={500}
        autoPlay
      />
      {status === "paused" && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 cursor-pointer">
          <div
            onClick={() => resumeRecording()}
            className="p-8 rounded-full bg-green-500 bg-opacity-20 hover:bg-opacity-30"
          >
            <FaPlay className=" w-12 h-12 text-green-500 " />
          </div>
        </div>
      )}
    </div>
  );
};
